import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';
import {ExstLabelsService} from '../../ExstLabelsStrategyService';
import type {ExstLabelsStrategyData} from '../../types/exst-labels-data.type';
import type {LabelListElement} from '../../../result-page/result-cards/subcomponents/uiaas-search-label-list';
import type {
  DeveloperPortalDocumentUiModel
} from '../../../../models/ui/documents/exchange/developer-portal-document-ui.model';

@Service({id: 'exstLabelsFallbackStrategyService'})
export class ExstLabelsFallbackStrategyBuilder extends StrategyBuilder<ExstLabelsFallbackStrategyService> {
  build(details: ExstLabelsStrategyData): ExstLabelsFallbackStrategyService {
      return new ExstLabelsFallbackStrategyService(details as unknown as Record<'labels', Array<keyof DeveloperPortalDocumentUiModel>>);
  }
}


export class ExstLabelsFallbackStrategyService extends ExstLabelsService {
  details;

  constructor(details: Record<'labels', Array<keyof DeveloperPortalDocumentUiModel>> = {labels: []}) {
      super();
      this.details = details;
  }

  getLabels(doc: DeveloperPortalDocumentUiModel): LabelListElement[] {
      return [];
  }
}
